export * from './getShorthandColor';
